import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=c2b969a0&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=c2b969a0&lang=scss&scoped=true&"
import style1 from "./Faq.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b969a0",
  null
  
)

component.options.__file = "Faq.vue"
export default component.exports